import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
import { Music24PlanId } from '../../config/music24StripePlans';
import { UpgradePlanOption } from './useUpgradePlanOptions';
import { upgradeMessages } from './upgradeMessages';
import styles from './SMLUpgradePlanOptions.module.scss';
import { withBrandWord } from '../primitives/BrandWord';

interface SMLUpgradePlanOptionsProps {
  options: UpgradePlanOption[];
  onSelect: (planId: Music24PlanId) => void;
}

/** Design b: the plans that unlock the feature. One is always selected; the cheapest comes first. */
const SMLUpgradePlanOptionsComponent: React.FC<SMLUpgradePlanOptionsProps> = ({ options, onSelect }) => {
  const intl = useIntl();
  return (
    <div className={styles.options} role="radiogroup" aria-label={intl.formatMessage(upgradeMessages.plansLabel)}>
      {options.map((option) => (
        <button
          key={option.id}
          type="button"
          role="radio"
          aria-checked={option.isSelected}
          className={clsx(styles.option, option.isSelected && styles.selected)}
          onClick={() => onSelect(option.id)}
        >
          <b className={styles.name}>{option.name}</b>
          {option.price !== null && <span className={styles.price}>{option.price}</span>}
          <small className={styles.detail}>{withBrandWord(option.detail)}</small>
        </button>
      ))}
    </div>
  );
};

export const SMLUpgradePlanOptions = TypedMemo(SMLUpgradePlanOptionsComponent);
